<template>
  <div
    v-if="enabled"
    class="absolute top-0 right-4 z-[2] dark:-top-2"
    :class="{
      '!-right-2 lg:!right-0 dark:!-right-2': !!noSidePadding,
      '!right-0 dark:!-right-2': !!isSliderCard,
    }">
    <NuxtImg format="webp" :src="src" quality="90" :height="isProductPage ? 160 : 128" :class="stickerStyles" />
  </div>
</template>

<script lang="ts" setup>
const props = defineProps<{
  enabled?: boolean
  src?: string
  noSidePadding?: boolean
  isProductPage?: boolean
  isSliderCard?: boolean
}>()

const stickerStyles = computed(() => {
  if (props.isProductPage) {
    return '!h-[79px] !max-w-[79px]'
  }

  return '!h-12 !max-w-12 lg:!h-16 lg:!max-w-16'
})
</script>
